<template lang="pug">
.wow__step.wow__step--first
  // eslint-disable vue/no-mutating-props
  .row
    .col-sm-3
      ValidationProvider(
        v-slot="{ errors, invalid, dirty }"
        vid="number"
        rules="required"
        slim
      )
        .form-group.wo-number-group(:class="{ 'has-error': (invalid && dirty) || !!form.errors.name }")
          label.control-label.required(for="wo-number")
            | Number
            abbr(title="required") *
          AppInput#wo-number(
            v-model="form.number"
            type="text"
            name="number"
            @input="onNumberChanged"
          )
          span.help-block(v-if="errors[0] && !form.errors.name") {{ errors[0] }}
          span.help-block(v-if="form.errors.name") {{ form.errors.name[0] }}
    .col-sm-9
      ValidationProvider(
        ref="clientValidationProvider"
        v-slot="{ errors }"
        vid="client"
        rules="required"
        slim
      )
        .form-group.wo-client-group(
          :class="{ 'has-error': !!errors[0] || !!form.errors.client || !!form.errors.client_id }"
        )
          label.control-label.required(for="wo-client")
            | Client
            abbr(title="required") *
          AppSelect#wo-client(
            ref="clientsSelect"
            v-model="form.client_id"
            name="client_id"
            :options="clientsOptions"
            :select2-options="clientsSelect2"
            @input="onSelectClient"
          )
          span.help-block(v-if="errors[0]") {{ errors[0] }}
          span.help-block(v-if="form.errors.client") {{ form.errors.client }}
  .row
    .col-sm-12
      ValidationProvider(
        v-slot="{ errors, invalid, dirty }"
        name="instructions"
        vid="instructions"
        rules="max:2000"
        slim
      )
        .form-group.wo-instructions-group.mb-0(:class="{ 'has-error': invalid && dirty }")
          label.control-label(for="wo-instructions")
            | Instructions
          textarea#wo-instructions.form-control(
            v-model="form.instructions"
            rows="5"
            name="instructions"
          )
          span.help-block(v-if="errors[0]") {{ errors[0] }}
          span.help-block(v-if="form.errors.instructions") {{ form.errors.instructions }}
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { debounce, isEmpty } from 'lodash-es';
import { WorkOrdersResource } from '~/resources';
import PhoneInputMixin from '~/mixins/WorkOrders/PhoneInputMixin';
import { mapInertiaProps } from '~/utils/inertia';
import { reportError } from '~/utils/errorReporter';

export default {
  name: 'CreateStep',
  mixins: [PhoneInputMixin],
  props: {
    groupedClients: {
      type: Array,
      required: true,
    },
    select2Options: {
      type: Object,
      default: () => ({}),
    },
    editing: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapInertiaProps({
      allClients: 'clients',
      organization: 'organization',
      newClientUrl: 'new_client_url',
    }),
    clientsOptions() {
      return [...this.groupedClients, { id: 'add-client', text: '+ Add client', new: true }];
    },
    clientsSelect2() {
      return {
        ...this.select2Options,
        placeholder: 'Select a client',
      };
    },
  },
  async created() {
    this.onNumberChanged = debounce(this.onNumberChanged.bind(this), 150);
    if (!this.editing) {
      await this.initializeWorkOrderNumber();

      if (this.allClients.length === 1) {
        this.form.client_id = this.allClients[0].id;
      }
    }
  },
  methods: {
    async onNumberChanged() {
      const response = await this.checkWorkOrder(this.form);

      this.form.clearErrors();

      if (!response.success) {
        if (isEmpty(response.errors)) {
          this.$appMessage('Unexpected error. Please try again.');
        } else {
          this.form.setError(response.errors);
        }
      }
    },
    async onSelectClient(clientId) {
      this.$refs.clientValidationProvider.reset();
      if (clientId === 'add-client') {
        this.$emit('toggle-client-dialog', true);
        AjaxDialog.run(this.newClientUrl);
        this.form.client_id = null;
        AjaxDialog.registerHook('response', 'newClientResponse', async (data) => {
          if (data.status === 'success') {
            const { id, address } = data;

            // Refresh the clients data
            await this.$inertia.reload({ only: ['clients'] });

            this.form.client_id = id;
            this.form.address = address;
            this.onSelectClient(`${id}`);
            this.$emit('toggle-client-dialog', false);
          } else {
            AjaxDialog.displayNotifications({ alert: data.message });
            this.setupPhoneInput();
          }
        });
      } else {
        this.form.client_id = parseInt(clientId);
      }
      // Make sure we don't select this option
      this.$refs.clientsSelect.remountSelect();
    },
    formatClientOption(option) {
      if (option.id !== 'add-client') {
        return option.text;
      }

      const element = document.createElement('div');

      element.classList.add('dropdown-new-item');
      element.innerText = option.text;

      return element;
    },
    async initializeWorkOrderNumber() {
      const number = await WorkOrdersResource.nextNumber({ organizationId: this.organization.id })
        .then((response) => (response.number ? response.number : null))
        .catch(() => null);

      this.form.number = number;
      if (!number) {
        this.$appMessage('Unexpected server error. Please try again');
      }
    },
    async checkWorkOrder(form) {
      const { id, number, client, client_id: cid } = form;
      const { id: organizationId } = this.organization;
      const clientId = client ? client.id : cid || null;
      const payload = { id, work_order: { client_id: clientId, number } };

      // TODO: Properly handle errors with Inertia form helper
      return WorkOrdersResource.check({ organizationId }, payload)
        .then((response) => response)
        .catch((e) => {
          reportError(`Bad response validate work order number`, { context: { payload, error: e } });

          return { success: false, valid: null };
        });
    },
  },
};
/* eslint-enable vue/no-mutating-props */
</script>
